/**
 * @generated SignedSource<<59dffefa314478fc66d0ed4906b3b05d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PollItem_poll$data = {
  readonly id: string;
  readonly startDate: string | null;
  readonly reward: {
    readonly formatted: string;
  } | null;
  readonly description: {
    readonly title: string;
  };
  readonly " $fragmentSpreads": FragmentRefs<"PollHeader_data">;
  readonly " $fragmentType": "PollItem_poll";
};
export type PollItem_poll$key = {
  readonly " $data"?: PollItem_poll$data;
  readonly " $fragmentSpreads": FragmentRefs<"PollItem_poll">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./PollItemRefetchQuery.graphql'),
      "identifierField": "id"
    }
  },
  "name": "PollItem_poll",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MoneyAmount",
      "kind": "LinkedField",
      "name": "reward",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "formatted",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "QuestionDescription",
      "kind": "LinkedField",
      "name": "description",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PollHeader_data"
    }
  ],
  "type": "PollQuestion",
  "abstractKey": null
};

(node as any).hash = "9f4edff1efc8e04f0c66a981c1756535";

export default node;
